(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kenza-about-frame"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('[data-kenza-frame]:not([data-kf-init])');
  if (!sections.length) return;

  sections.forEach(initSection);

  function initSection(section) {
    section.setAttribute('data-kf-init', 'true');

    const animate = section.getAttribute('data-animate') !== 'false';
    const float = parseInt(section.getAttribute('data-float') || '10', 10);
    section.style.setProperty('--kf-float', float);

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ── In-view observer (start all entrance animations) ────
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.setAttribute('data-in-view', 'true');
          startCounters(section);
          io.unobserve(section);
        }
      });
    }, { threshold: 0.15 });
    io.observe(section);

    // ── Mouse parallax (desktop only, no reduced motion) ────
    if (animate && !prefersReducedMotion && window.matchMedia('(min-width: 901px)').matches) {
      initParallax(section);
    }

    // ── Decorative letter parallax on scroll ────────────────
    const decor = section.querySelector('[data-decor]');
    if (decor && animate && !prefersReducedMotion) {
      initScrollParallax(section, decor);
    }
  }

  // ── Counter animation for stat-badges ─────────────────────
  function startCounters(section) {
    const counters = section.querySelectorAll('[data-counter]');
    counters.forEach(el => {
      const target = parseFloat(el.getAttribute('data-counter'));
      if (isNaN(target)) return;
      const duration = 1800;
      const start = performance.now();
      const isDecimal = target % 1 !== 0;
      function step(now) {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        // ease-out cubic
        const eased = 1 - Math.pow(1 - progress, 3);
        const value = target * eased;
        el.textContent = isDecimal ? value.toFixed(1) : Math.round(value).toLocaleString('nl-NL');
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  // ── Mouse parallax — portrait + badges drift toward cursor
  function initParallax(section) {
    const portrait = section.querySelector('[data-portrait]');
    const blocks = section.querySelectorAll('.kf-block');
    let rafId = null;
    let targetX = 0, targetY = 0;
    let currentX = 0, currentY = 0;

    function onMove(e) {
      const rect = section.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      targetX = (e.clientX - cx) / rect.width;
      targetY = (e.clientY - cy) / rect.height;
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    function tick() {
      currentX += (targetX - currentX) * 0.08;
      currentY += (targetY - currentY) * 0.08;

      if (portrait) {
        portrait.style.transform = `translate(${currentX * 8}px, ${currentY * 8}px)`;
      }
      blocks.forEach((b, i) => {
        const factor = (i % 2 === 0) ? 14 : 10;
        const existingTransform = b.style.transform.replace(/translate\([^)]*\)\s*/g, '');
        b.style.setProperty('--kf-parallax-x', `${currentX * factor}px`);
        b.style.setProperty('--kf-parallax-y', `${currentY * factor}px`);
      });

      if (Math.abs(targetX - currentX) > 0.001 || Math.abs(targetY - currentY) > 0.001) {
        rafId = requestAnimationFrame(tick);
      } else {
        rafId = null;
      }
    }

    section.addEventListener('mousemove', onMove);
    section.addEventListener('mouseleave', () => {
      targetX = 0; targetY = 0;
      if (!rafId) rafId = requestAnimationFrame(tick);
    });
  }

  // ── Scroll parallax for decorative letter ─────────────────
  function initScrollParallax(section, decor) {
    let rafId = null;
    function update() {
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = (vh - rect.top) / (vh + rect.height);
      const translate = (progress - 0.5) * 80;
      decor.style.transform = `translate(-50%, calc(-50% + ${translate}px))`;
      rafId = null;
    }
    function onScroll() {
      if (!rafId) rafId = requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
